import styled from '@emotion/styled';
import {
  bodyB,
  bodyM,
  captionM,
  captionSb,
  title2,
} from '@teamsparta/stack-font';
import { vars } from '@teamsparta/stack-tokens';

import { DESKTOP } from '@/styles/themes';

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: 40px;
  * {
    margin: 0;
  }
`;
export const VideoWrapper = styled.div<{ allBordersRadius?: boolean }>`
  position: relative;
  left: -16px;
  width: calc(100% + 32px);
  aspect-ratio: 367/206;
  line-height: 0;

  ${DESKTOP} {
    left: unset;
    width: 100%;
    video {
      border-radius: ${({ allBordersRadius }) => allBordersRadius && '12px'};
      border-top-left-radius: 12px;
      border-top-right-radius: 12px;
    }
  }
`;
export const ThumbnailWrapper = styled(VideoWrapper)`
  overflow: hidden;
  ${DESKTOP} {
    border-radius: 12px;
  }
`;

export const PreviewMessageAndLoginButton = styled.div`
  width: 100%;
  background: #2b2d2e;
  padding: 12px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
  ${DESKTOP} {
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
  }
`;
export const PreviewMessage = styled.div`
  color: ${vars.neutral[50]}!important;
  ${captionM};
  ${DESKTOP} {
    ${captionM};
  }
`;
export const LoginButton = styled.button`
  padding: 4px 8px;
  ${captionM};
  font-size: 12px;
  color: white;
  background-color: ${vars.brand.default};
  border: none;
  border-radius: 4px;
  cursor: pointer;
  ${DESKTOP} {
    font-size: 13px;
    padding: 8px 16px;
  }
`;
export const PreviewMessageBold = styled.strong`
  display: block;
  color: ${vars.neutral[30]}!important;
  ${captionSb};
  ${DESKTOP} {
    display: initial;
    margin-right: 8px;
    ${captionSb};
  }
`;
export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  ${DESKTOP} {
    justify-content: space-between;
    flex-direction: row;
    gap: 12px;
  }
`;
export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const Title = styled.h1`
  ${title2};
  color: ${vars.neutral[0]};
  word-break: keep-all;
  ${DESKTOP} {
    height: 44px;
    display: flex;
    align-items: center;
    ${title2};
    color: ${vars.neutral[0]};
  }
`;
export const SocialContainer = styled.div`
  display: flex;
  gap: 12px;
`;
export const SocialButton = styled.button`
  &.active {
    background-color: #2b2d2e;
  }
  flex: 1;
  height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;

  border: 1px solid ${vars.neutral[80]};
  background-color: transparent;
  border-radius: 8px;
  cursor: pointer;

  ${bodyB};
  color: ${vars.neutral[0]};
  ${DESKTOP} {
    width: 86px;
    ${bodyB};
    color: ${vars.neutral[0]};
    svg {
      width: 20px;
      height: 20px;
    }
  }
`;

export const VideoInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
export const VideoInfo = styled.div`
  display: flex;
  gap: 16px;
  ${DESKTOP} {
    gap: 24px;
  }
`;

export const DetailInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  ${captionM};
  color: ${vars.neutral[50]};
  ${DESKTOP} {
    ${bodyM};
    color: ${vars.neutral[50]};
  }
`;
